export default __webpack_public_path__ + "static/media/PressRelease-Sanathan-Textiles-on-track-to-double-Technical-Textiles-Capacity-at-Silvassa.a6631a72.pdf";